import {Model} from "ords/dist/model/model";

export class AssignmentStatus extends Model {

    isInPristineSate() {
        return this.finished === 0 && this.status === 0;
    }

    isWaitingForSubmit() {
        return this.status !== 1 && this.finished === 0;
    }

    isInSubmittedState() {
        return this.finished === 1 && this.status === 0;
    }

    isInClosedState() {
        return this.status === 1;
    }

    isInReopenedState() {
        return this.finished === 0 && this.status === 2;
    }

    hasLogs(){
        return this.logs.length;
    }

    getLogs(){
        if(this.hasLogs()){
            return this.logs.sort(function (a, b){
                return new Date(b.created_at) - new Date(a.created_at);
            })
        }

        return null;
    }
    hasActivities(){
        return this.activities.length;
    }

    getActivities(){
        if(this.hasActivities()){
            return this.activities.sort(function (a, b) {
                return new Date(b.created_at) - new Date(a.created_at);
            })
        }
    }
}

export const AssignmentStatusModelConfig = {
    name: 'assignmentStatus',
    model: AssignmentStatus,
    relations: [
        {name: 'logs', model_name: 'assignmentStatusLog', type: 'hasMany'},
        {name: 'activities', model_name: 'assignmentStatusActivity', type: 'hasMany'}
    ]
}
